export default __webpack_public_path__ + "static/media/gallery_2_768.f27e103c.webp";